module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.dc81817.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Bold.woff
// module id = 311
// module chunks = 1